// The Frames by Model & Colour guide (67_ModelColor.jsx · ModuleHelp, Max 01/11).
const en = {
  tabsT: 'Three views',
  tabsB: 'Dashboard summarises the frames shipped, By year is the model and frame colour table by year, and One month is what is shipped in a single month. Click a tab to switch.',
  filtersT: 'Filters',
  filtersB: 'Pick one or more Lines, Models, Frame colours and Years; each list has a search box. Every view and the Excel file follow these choices.',
  toolsT: 'Excel and upload',
  toolsB: 'Excel downloads the table with the lines you picked. If you may upload, the Upload button reads a new Order Status workbook so the counts catch up.',
  dashT: 'Dashboard',
  dashB: 'Total frames, the top colour and the charts for the lines and years you picked.',
  yearT: 'Model and colour by year',
  yearB: 'One row per model and frame colour, one column per year, the Total right under the header. Click a counted number to see the lines behind it.',
  monthT: 'One month',
  monthB: 'Pick the month to see the frames shipped in it by model and colour. Click a quantity to see the lines behind it.',
};
const ko = {
  tabsT: '세 가지 보기',
  tabsB: 'Dashboard는 출하 프레임 요약, By year는 모델·프레임 색상별 연도 표, One month는 한 달 출하량입니다. 탭을 클릭해 전환하세요.',
  filtersT: '필터',
  filtersB: 'Line, Model, 프레임 색상, 연도를 하나 이상 고릅니다. 각 목록에는 검색창이 있습니다. 모든 보기와 Excel 파일이 이 선택을 따릅니다.',
  toolsT: 'Excel과 업로드',
  toolsB: 'Excel은 선택한 line의 표를 내려받습니다. 업로드 권한이 있으면 Upload 버튼으로 새 Order Status 워크북을 읽어 집계를 최신으로 맞춥니다.',
  dashT: 'Dashboard',
  dashB: '선택한 line과 연도의 총 프레임 수, 상위 색상, 차트를 보여줍니다.',
  yearT: '연도별 모델과 색상',
  yearB: '모델·프레임 색상마다 한 행, 연도마다 한 열이며 합계는 제목 바로 아래에 있습니다. 집계된 숫자를 클릭하면 근거가 되는 라인을 볼 수 있습니다.',
  monthT: '한 달',
  monthB: '월을 고르면 그 달에 출하된 프레임을 모델·색상별로 볼 수 있습니다. 수량을 클릭하면 근거 라인이 열립니다.',
};
const vi = {
  tabsT: 'Ba cách xem',
  tabsB: 'Dashboard tóm tắt số frame đã xuất, By year là bảng model và màu frame theo năm, còn One month là số xuất trong một tháng. Bấm vào tab để chuyển.',
  filtersT: 'Bộ lọc',
  filtersB: 'Chọn một hoặc nhiều Line, Model, màu frame và năm; mỗi danh sách có ô tìm kiếm. Mọi chế độ xem và file Excel đều theo các lựa chọn này.',
  toolsT: 'Excel và upload',
  toolsB: 'Excel tải bảng theo các line bạn chọn. Nếu bạn được phép upload, nút Upload sẽ đọc file Order Status mới để số liệu được cập nhật.',
  dashT: 'Dashboard',
  dashB: 'Tổng số frame, màu bán chạy nhất và các biểu đồ theo line và năm bạn đã chọn.',
  yearT: 'Model và màu theo năm',
  yearB: 'Mỗi dòng là một model kèm màu frame, mỗi cột là một năm, dòng Total nằm ngay dưới tiêu đề. Bấm vào một số đã đếm để xem các dòng tạo nên số đó.',
  monthT: 'Một tháng',
  monthB: 'Chọn tháng để xem số frame đã xuất trong tháng đó theo model và màu. Bấm vào số lượng để xem các dòng phía sau.',
};
const zh = {
  tabsT: '三种视图',
  tabsB: 'Dashboard 汇总已出货的 frame，By year 是按年份的型号与 frame 颜色表，One month 是单月出货。点击标签即可切换。',
  filtersT: '筛选器',
  filtersB: '可选择一个或多个 Line、Model、frame 颜色和年份；每个列表都有搜索框。所有视图和 Excel 文件都跟随这些选择。',
  toolsT: 'Excel 与上传',
  toolsB: 'Excel 会下载所选 line 的表格。如果您有上传权限，Upload 按钮会读取新的 Order Status 工作簿，使统计保持最新。',
  dashT: 'Dashboard',
  dashB: '显示所选 line 和年份的 frame 总数、排名第一的颜色和图表。',
  yearT: '按年份的型号与颜色',
  yearB: '每个型号和 frame 颜色一行，每个年份一列，合计行紧贴表头下方。点击已统计的数字可查看其背后的明细行。',
  monthT: '单月',
  monthB: '选择月份，按型号和颜色查看当月出货的 frame。点击数量可查看其背后的明细行。',
};

const dictionary = { ns: 'tourModelColor', en, ko, vi, zh };
export default dictionary;
